$(document).ready(function() {
  $(".submit-collection-session").click(function() {
    var is_current = $("#radio-button-is-current input[type='radio']:checked").val();

    if (is_current == 'true') {
      var text_alert = ''
      var title      = $('#collection-session-title').val();

      if (confirm(I18n.t('global.notices.are_you_sure') + `\n - ${title} ` + I18n.t('global.notices.is_the_current_collection_session'))) {
        return true
      } else {
        return false
      }
    }
  });
})
